/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('shared').filter('formatSize', ['fileSizeFormatter', fileSizeFormatter =>
  size => fileSizeFormatter.humanFileSize(size)
]);
